import FAQBox from "components/FAQs/IN-8003FHD/faqBox";
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  FAQBox,
  BreadCrumbs,
  SEOHelmet,
  React
};